import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles((theme: Theme) => ({
    spinner: {
        color: theme.palette.primary.contrastText,
    },
}));
